var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPinOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 52,
    viewBox: "0 0 44 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -620) translate(97 375) translate(1 57.5) translate(276 89.5) translate(307 98) translate(3 3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 45,
    fill: "#000",
    opacity: 0.181,
    rx: 11,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#23DF78",
    d: "M19 0c10.493 0 19 8.562 19 19.124 0 5.912-2.665 11.198-6.853 14.706l-10.33 10.398c-.997 1.003-2.618 1.009-3.621.012l-.012-.012L6.853 33.83C2.665 30.322 0 25.036 0 19.124 0 8.562 8.507 0 19 0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.6 3.2H16V21.599999999999998H1.6z",
    transform: "translate(10 7)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.6,
    d: "M4.8 18.4H12.8V22.4H4.8z",
    transform: "translate(10 7)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.8,
    d: "M4.4 5.2H7.6000000000000005V6.2H4.4zM4.4 8.4H7.6000000000000005V9.4H4.4zM10 5.2H13.2V6.2H10zM10 8.4H13.2V9.4H10zM4.4 11.6H7.6000000000000005V12.6H4.4zM10 11.6H13.2V12.6H10zM4.4 14.8H7.6000000000000005V15.8H4.4zM10 14.8H13.2V15.8H10z",
    transform: "translate(10 7)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.6,
    d: "M0.8 2.4H16.8V22.4H0.8z",
    transform: "translate(10 7)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.8,
    d: "M0.4 0.4H5.2V1.4H0.4z",
    transform: "translate(10 7)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinOk);
export default __webpack_public_path__ + "static/media/ic-pin-ok.ff560aa46a52396258e8b94069b623a1.svg";
export { ForwardRef as ReactComponent };